import {Component, Input, OnInit, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {ButtonComponent} from "@syncfusion/ej2-angular-buttons";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {EditorComponent} from "@tinymce/tinymce-angular";
import {SystemJournalEmailModel} from "./system-journal-email.model";
import {ComboBoxComponent} from "@syncfusion/ej2-angular-dropdowns/src/combo-box/combobox.component";
import {TextBoxComponent} from "@syncfusion/ej2-angular-inputs/src/textbox/textbox.component";
import {UtilService} from "../../../services/util/util.service";
import {RequestService} from "../../../services/request/request.service";
import { ItemModel } from '@syncfusion/ej2-angular-splitbuttons';
import {MenuEventArgs, ClickEventArgs} from "@syncfusion/ej2-splitbuttons";

@Component({
  selector: 'sb-system-journal-email',
  templateUrl: './system-journal-email.component.html',
  styleUrls: ['./system-journal-email.component.scss'],
})
export class SystemJournalEmailComponent implements OnInit {

  @Input()
  set context(context: any) {
    this.recordId = context.recordId;
    this.recordTable = context.recordTable;
    this.isNewRecord = context.isNewRecord;
    this.record = context.record;
    this.root = context.root;
    this.recordField = this.root.relatedRecordField;
    this.init();
  }

  @ViewChild("newButton", {static: false})
  newButton: ButtonComponent;

  @ViewChild("newDialog", {static: false})
  newDialog: DialogComponent;

  // Single components - might not be needed
  @ViewChild("newDialogEditor", {static: false})
  newDialogEditor: EditorComponent;

  // Arrays of components per email per tab
  @ViewChildren("newDialogFrom")
  newDialogFroms: ComboBoxComponent[];

  @ViewChildren("newDialogTo")
  newDialogTos: ComboBoxComponent[];

  @ViewChildren("newDialogCC")
  newDialogCCs: ComboBoxComponent[];

  @ViewChildren("newDialogBCC")
  newDialogBCCs: ComboBoxComponent[];

  @ViewChildren("newDialogSubject")
  newDialogSubjects: TextBoxComponent[];

  @ViewChildren("newDialogEditor")
  newDialogEditors: EditorComponent[];

  newDialogButtons: ButtonPropsModel[] = [
    {
      'click': this.newDialogHideDialog.bind(this, false, false, false),
      buttonModel: {
        content: 'Discard',
      }
    },
    {
      'click': this.newDialogHideDialog.bind(this, true, true, false),
      buttonModel: {
        content: 'Send',
      }
    },
    {
      'click': this.newDialogHideDialog.bind(this, true, false, true),
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      }
    },
  ];

  public newDialogSplitButtonItems: ItemModel[] = [
    {
      text: 'Outbound notification',
      id: 'outbound'
    },
    {
      text: 'New message',
      id: 'new'
    },
  ];

  newDialogPosition: any = { X: 'center', Y: 'center' };

  newDialogVisible: boolean = false;

  newDialogTitle = "Email";

  newDialogToggleState = {
    CC: false,
    BCC: false,
  };

  newDialogEditorConfig: any = {
    fixed_toolbar_container: "#newDialogEditor",
    branding: false,
    statusbar: false,
    menubar: false,
    autosave_ask_before_unload: false, /* We have our own dirty form checking */
    plugins: [
      "autoresize", "image", "print", "table",
      "paste", "lists", "link", "advlist", "preview",
      "noneditable"
    ],
    contextmenu: false,
    toolbar: [
      "image link attachFile attachmentSelector | bold italic underline strikethrough | bullist numlist"
    ],
    /* Allow onclick for anchor element because of onclick added in SofiClient script library */
    extended_valid_elements: "a[href|onclick|target|rel|title]",
    skin_url: "/css/SB-MCE",
    content_css: ["/css/SB-MCE/content.min.css",
                  "/css/SB-MCE/non-editable.css"],
    browser_spellcheck: true,
    default_link_target: "_blank",
    paste_data_images: true,
    block_unsupported_drop: false,
    resize: false,
    noneditable_editable_class: "is-editable",
    noneditable_noneditable_class: "is-locked",
    object_resizing : false, // Workaround for non-editable table bug, where editor doesn't obey it for tables
    table_toolbar: '' // Workaround for non-editable table bug, where editor doesn't obey it for tables
  };

  newDialogEditorModel = "";

  // Context for the email client, which will be a field on a detail form
  recordId: string;
  recordTable: string;
  isNewRecord: boolean;
  record: any;
  root: any;
  recordField: string;

  // OutboundNotification generated email data
  outboundEmailData: SystemJournalEmailModel[] = [];
  outboundEmailDataError: boolean = false;

  emptyEmailData: SystemJournalEmailModel[] = [{
    MessagingAccount: "",
    From: "",
    Recipients: "",
    RecipientsCC: "",
    RecipientsBCC: "",
    Subject: "",
    Body: "",
  }];

  showEmailDialog: boolean = false;

  showEmailDialogEmptyDataOverride: boolean = false;

  constructor(private utilService: UtilService, private requestService: RequestService) {
  }

  ngOnInit(): void {
  }

  async init() {

    if (!this.isNewRecord) {
      const requestOptions = {
        _requestType: "outboundNotificationData",
        _recordId: this.recordId,
        _recordTable: this.recordTable,
        _recordField: this.recordField
      };

      const response = await (window as any).WS.controller("NotificationController", requestOptions);

      const data = response.data;

      if (data.isError) {
        console.error("SystemJournalEmailComponent: " + data.error);
        this.outboundEmailDataError = true;
      } else {
        this.outboundEmailData = data;
        if (this.outboundEmailData.length > 0) {
          for (const d of this.outboundEmailData) {
            const originalBody = d.Body;
            const wrappedBody = '<div class="is-locked">' + originalBody + '</div>';
            const substitute = '<div class="is-locked is-editable-wrapper" title="Editable content"><div class="is-editable"></div></div>';
            const substitutedBody = wrappedBody.replace('[PLACEHOLDER]', substitute);
            d.Body = substitutedBody;
            d.From = await this.getFromAddress(d.MessagingAccount);
          }
        }
      }

      this.emptyEmailData[0].From = await this.getFromAddress(null);
    }
  }

  newDialogHideDialog(process: boolean, toEmail: boolean, toJournal: boolean) {
    this.newDialog.hide();

    if (process) {
      if (toJournal) {
        this.record[this.recordField].value(this.newDialogEditorModel);
      }
      if (toEmail) {

      }
    }
    this.showEmailDialog = false;
  }

  newDialogButtonSelect(e: any) {
    this.showEmailDialog = true;
    this.showEmailDialogEmptyDataOverride = false;
    this.newDialogShow();
  }

  newDialogSplitButtonSelect(e: MenuEventArgs | ClickEventArgs, click: boolean) {
    this.showEmailDialog = true;
    this.showEmailDialogEmptyDataOverride = (e as any)?.item?.id == 'new' && click == false;
    this.newDialogShow();
  }

  private newDialogShow() {
    this.utilService.tickThen(async () => {
      await this.init(); // In case the recipients have changed due to a change on the form.
      await this.newDialogPrepare();
      this.utilService.tickThen(() => {
        this.newDialog.show();
      });
    });
  }

  priva
  async newDialogPrepare() {
    // Prepare the new dialog with relevant items for the fields, for example
    // the default settings for To, Subject etc (from an OutboundNotification, perhaps)
    this.newDialogEditorModel = "";
  }

  newDialogClose(e: any) {
    // The 'x' or ESC button
  }

  newDialogToggle(id: string) {
    this.newDialogToggleState[id] = !this.newDialogToggleState[id];
  }

  newDialogToggleVisible(id: string, state: boolean) {
    return this.newDialogToggleState[id] === state;
  }

  async getFromAddress(messagingAccountId: String) {
    const parameters = {
      messagingAccountId: messagingAccountId,
    };

    const response: any = await this.requestService.createRequest()
      .controller("servicely.core.Message")
      .method("getEmailFromAddress")
      .data(parameters)
      .execute();

    return response.data.emailFromAddress;
  }
}
